import { Component } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { User } from '../../users/user';

@Component({
  selector: 'reviewer-cell',
  template: `
    <div class="value">{{ (value.amount | translate) || 'N/A' }}</div>
    <div class="label">{{ value.reviewer && 'By ' + value.reviewer }}</div>
  `,
  styles: [`
    .value {
      height: 50%;
      font-weight: 600;
      line-height: 34px;
    }
    .label {
      opacity: 0.75;
      height: 50%;
      font-size: 12px;
      line-height: 16px;
    }
  `]
})
export class ReviewerCellComponent implements AgRendererComponent {
  value!: {
    amount: any
    reviewer: string
  };
  reviewer!: User;

  constructor() { }

  agInit(params: any): void {
    this.value = params.value;
    this.reviewer = params.reviewer;
  }

  refresh(): boolean {
    return false;
  }

  getValue(): { amount: any; reviewer: string } {
    return this.value;
  }
}
